import './Status.css';

export default function Status({ color, description }) {
  return (
    <div className={`status ${color}`} data-tooltip={description || null} />
  );
}
